// LocationTypes code
export enum LocationTypes {
    Register = 'Register',
    Stand = 'Stand',
    ThirdPartyProperty = 'ThirdPartyProperty',
    Property = 'Property',
    Region = 'Region'
}